/**
 * @deprecated Import from './layerConfig' instead.
 * This file re-exports from layerConfig.ts for backwards compatibility.
 */

export {
  LAYER_COLORS,
  LAYER_COLOR_CLASSES,
  type LayerColorKey,
  LAYER_CONFIGS,
  LAYER_CONFIG_MAP,
  getLayerConfig,
  type LayerConfig,
  type LayerColorConfig,
} from './layerConfig';

// Wishlist legend styling (includes dashed border effect)
// Kept here for backwards compatibility
import { LAYER_COLOR_CLASSES, LAYER_COLORS } from './layerConfig';
export const WISHLIST_LEGEND_CLASSES = `${LAYER_COLOR_CLASSES.wishlist} border-2 border-dashed border-[${LAYER_COLORS.wishlist.primary}]/60 opacity-80`;
